const AUTH_CHANNEL_NAME = 'auth_channel';

export class AuthBroadcast {
    private channel: BroadcastChannel | null = null;

    constructor() {
        if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
            this.channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
        }
    }

    notifyLogin() {
        this.channel?.postMessage({type: 'LOGIN'});
    }

    notifyLogout() {
        this.channel?.postMessage({type: 'LOGOUT'});
    }

    subscribe(callback: (message: {type: 'LOGIN' | 'LOGOUT'}) => void) {
        if (!this.channel) return () => {};

        const handler = (event: MessageEvent) => callback(event.data);
        this.channel.addEventListener('message', handler);
        return () => this.channel?.removeEventListener('message', handler);
    }

    close() {
        this.channel?.close();
    }
}

export const authBroadcast = new AuthBroadcast();
